// replacementGen is a function(currentValue) that will provide a replacement
import _ from 'underscore';
// value for the specified key.
export function replaceKeyInJSON(json, keyToReplace, replacementGen) {
    if (_.isArray(json)) {
        _.each(json, (element) => {
            replaceKeyInJSON(element, keyToReplace, replacementGen);
        });
    }
    else if (_.isObject(json)) {
        replaceKeyInDict(json, keyToReplace, replacementGen);
    }
}
export function replaceKeyInDict(obj, keyToReplace, replacementGen) {
    _.each(_.keys(obj), (key) => {
        const value = obj[key];
        if (keyToReplace === key) {
            obj[key] = replacementGen(value);
        }
        else {
            replaceKeyInJSON(value, keyToReplace, replacementGen);
        }
    });
}
//# sourceMappingURL=universal_json_helper.js.map